export function getLastName(str) {
  return String(str || "")
    .trim()
    .split(" ")
    .pop();
}
